import { Loader } from 'components';
import { ResetSuccessfulModal } from 'components/modal-variants';
import { NewPasswordUI } from 'features';
import { queryObject } from 'helpers';
import { useResetPassword } from 'hooks';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Interface for reset password payload
 */
export interface ResetPasswordPayload {
  email: string;
  token: string;
  password: string;
}

const NewPassword = () => {
  const [success, setSuccess] = useState(false);
  const [clear, setClear] = useState(false);
  const { search } = useLocation();

  const { email, token } = queryObject(search);
  // Hooks
  const { mutate: resetPassword, isPending } = useResetPassword(setSuccess, setClear);

  const submit = (data: { password: string }) => {
    resetPassword({ email, token, password: data.password });
  };

  const showLoader = isPending;

  return (
    <>
      <Loader loading={showLoader} />
      <ResetSuccessfulModal show={success} close={() => setSuccess(false)} />
      <NewPasswordUI clear={clear} submit={submit} />
    </>
  );
};

export { NewPassword };